<!--
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-04-22 13:32:07
 * @LastEditors: liujunyao
 * @LastEditTime: 2022-04-22 16:26:48
 * @FilePath: /privacy-web/src/components/PrivacyProtect/ManageProcessContent.vue
-->
<template>
  <div
    class="Manage-process-content-main"
    :class="{ 'Manage-process-content-main-mobile': isMobile }"
  >
    <div class="headers">
      贝壳找房覆盖全中国超过300个城市，
      服务超过2亿的社区家庭，链接100万职业经纪人和10万家门店，
      赋能超过100个品牌。为了保障客户更好的服务体验，贝壳“从线上化到数字化”，开创了整合式创新的管理流程。
    </div>
    <div class="main">
      <ManageProcessContentItem
        v-for="item in dataList"
        :key="item.id"
        :data="item"
      ></ManageProcessContentItem>
    </div>
  </div>
</template>
<script>
export default {
  name: "ManageProcessContent",
  data() {
    return {
      dataList: [
        {
          title: "数字化管理",
          content: [
            "内生安全防护体系",
            "B端链接赋能",
            "ACN经纪人合作规则",
            "服务质量激励机制",
            "用户体验承诺机制",
          ],
          id: 1,
        },
        {
          title: "线下门店标准统一",
          content: ["结构化统一管理", "真实房源 真实图片 真实价格"],
          id: 2,
        },
        {
          title: "隐私保护培训管理",
          content: [
            "自上而下的隐私保护理念培训",
            "全方位多角色的隐私合规专项培训",
            "隐私评价体系 推动内部隐私全面治理",
          ],
          id: 3,
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.Manage-process-content-main {
  margin-top: calc($multiple * 28px);
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.headers {
  height: calc($multiple * 72px);
  width: 100%;
  font-size: calc($multiple * 14px);
  font-family: PingFangTC-Regular, PingFangTC;
  font-weight: 400;
  color: #8b8b8b;
  line-height: calc($multiple * 36px);
  letter-spacing: 1px;
}
.main {
  margin-top: 62px;
  display: flex;
}
.Manage-process-content-main-mobile {
  margin-top: 1.84rem;
  .headers {
    width: 17.15rem;
    height: 3.93rem;
    font-size: 0.61rem;
    line-height: 0.98rem;
    letter-spacing: 0.05rem;
    margin-bottom: 1.04rem;
  }
  .main {
    margin-top: 1.6rem;
    flex-direction: column;
  }
}
</style>
